import type { SolarPanelsSuitabilityCheckState } from '../../store';
import { initialSolarPanelsSuitabilityCheckState } from '../../store';

export const mockSolarPanelsSuitabilityCheckViewModel: SolarPanelsSuitabilityCheckState =
  {
    ...initialSolarPanelsSuitabilityCheckState,
    isVisible: true,
  };
